import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import mainAxios from "../../../services/mainAxios";
import Loader from "../../Layout/Loader";
import Page404 from "../../Page404";
import invoiceActions from "../../../services/invoiceActions.json";
import invoiceStatuses from "../../../services/invoiceStatuses.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faQuestionCircle,
  faRedo,
  faPrint,
  faPaperPlane,
  faChevronRight,
  faChevronLeft,
  faCopy,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Accordion from "../WizardSteps/Accordion";
import ThermalPrinterInvoiceContent from "../ThermalPrinterInvoiceContent";
import AlertCertificate from "../../global/AlertCertificate";
import moment from "moment";
import { useAppContext, usePersistedState } from "../../../AppContext";
import func, { translateLabel, removePropertiesRecursive, validateInvoice } from "../../../services/functions";
import DemoInvoiceTotals from "./DemoInvoiceTotals";
import DemoTable from "./DemoTable";
import DemoInvoiceFiscalization from "./DemoInvoiceFiscalization";
import PopOver from "../../global/PopOver";
import DemoInvoiceTabsNAT from "./DemoInvoiceTabsNAT";
import DemoParties from "./DemoParties";
import DemoSideMenu from "./DemoSideMenu";
import DemoInvoiceDatas from "./DemoInvoiceDatas";
import MobileInvoiceWizard from "./MobileInvoiceWizard";
import Swal from "sweetalert2";
import {  typeOfPaymentMeansCash, typeOfPaymentMeansNonCash } from "../WizardSteps/data";
import useShowInvoicePdf from "../../global/useShowInvoicePdf";
import { duplicateInvoice } from "../Utils";

const DemoEditInvoice = (props) => {
  const { t, i18n } = useTranslation("translations");
  const [invoice, setInvoice] = React.useState(null);

  const [pageLoading, setPageLoading] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [duplicateLoading, setDuplicateLoading] = React.useState(false);
  const [bankAccounts, setBankAccounts] = React.useState([]);
  const [unitsOfMeasure, setUnitsofMeasure] = React.useState([]);
  const [partiesDialog,setPartiesDialog]=useState({open:false,id:null,party:null})
  const [sideBarVisible, setSideBarVisible] = usePersistedState(true,"sideBar1")
  const [refreshInvoice,setRefreshInvoice]=useState(false)
  const { showInvoicePdf,pdfEmbed,loadingPdf } = useShowInvoicePdf()

  const {
    user: [user],
    selectedCompany: [selectedCompany],
    company: [fullCompany],
    refreshStatuses=[]
  } = useAppContext();
  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );
  
  const invoiceId = props.match.params.id;

  const [invoiceAutosave,setInvoiceAutosave]=usePersistedState("false","invoiceAutosave")

  const lastStateRef = useRef();
  const lastStateHelper = useRef();
  const stateRef = useRef();
  const invoiceAutosaveRef=useRef()



  React.useEffect(() => {
    setLoading(true)
    mainAxios
      .post("apiEndpoint/search", {
        object: "GetCustomInvoice",
        params: {
          id: invoiceId,
        },
      })
      .then((res) => {
        if (res?.data?.status) {
          const parsedInvoice = func.parseCustomInvoiceResponse(
            res.data.content[0]
          );
          lastStateRef.current = parsedInvoice
          //this is needed for calculations inside demotable,because the calculations change the invoiceState totals type from number to string that effects autosave to see this as a change of state and it will save the invoice unneccessarly
          lastStateHelper.current={saved:true}
          setInvoice(parsedInvoice);
          setPageLoading(false);
        }
        setLoading(false);
      })
      .catch(()=>{
        setLoading(false)
      })
  }, [selectedCompany, props.match.params.id,refreshInvoice]);

  React.useEffect(() => {
    if (fullCompany?.id) {
      setBankAccounts(fullCompany.bankAccounts || []);
    }
  }, [fullCompany?.id]);


  useEffect(()=>{
    invoiceAutosaveRef.current = invoiceAutosave
  },[invoiceAutosave])

  useEffect(()=>{
    stateRef.current = invoice
  },[invoice])

  useEffect(() => {
    if(invoiceAutosave!=="1") return

    const interval = setInterval(()=>{
      const saveStatusId=stateRef?.current?.status?.id
      if(invoiceAutosaveRef.current !=="1" || (saveStatusId && saveStatusId!==7)) return
      const isEqual = JSON.stringify(stateRef.current) === JSON.stringify(lastStateRef.current)

      if(!isEqual){
        handleInvoice({autosave:true,autoSaveState:stateRef.current})
      }

    },30000)

    return () => clearInterval(interval);

  }, [invoiceAutosave])





  const [errors, setErrors] = useState({});
  const validatedInvoice = () => {
    const {
      hasTransport,
      vehiclePlate,
      transporter,
      destinationAddress,
      badDebtInv,
      selfInvoice,
      sumInv,
      correctiveInv,
    } = invoice;

    const types = [badDebtInv, selfInvoice, sumInv, correctiveInv];
    if (types.filter((type) => type).length > 1) {
      toast.warning(
        "Invoice can only be one of the following 'Bad Debt', 'Self Invoice', 'Summary Invoice', or 'Corrective Invoice'",
        { containerId: "all_toast" }
      );
    } else if (sumInv && !["380", "82", "388","385"].includes(invoice.type)) {
      toast.warning(
        "Summary Invoice needs to be of types '380','385', '82', or '388'",
        { containerId: "all_toast" }
      );
    } 
    else if (
      ((badDebtInv || correctiveInv) && !sumInv) &&
      (!invoice.iic_ref || !invoice.refInvIssueDateTime)
    ) {
      document.querySelector("#iicRef").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      toast.warning("IIC Reference and Reference Issue Date are required!", {
        containerId: "all_toast",
      });
    }

    else if (invoice.parties.buyer.buyerIDType!=null && invoice.parties.buyer.tin.length < 1) {
      document.querySelector("#invoice_buyer").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      document.querySelector("#invoice_buyer [name='buyer']").focus();
      toast.warning(t(["toast.buyerInfo"]), { containerId: "all_toast" });
      return false;
    } else if (
      (process.env.REACT_APP_ALLOW_INVOICE_NR === "true" &&
        invoice.number?.length < 1) ||
      (!invoice.issueDate || invoice.issueDate.length) < 1 ||
      !invoice.dueDate ||
      invoice.dueDate.length < 1
    ) {
      document.querySelector("#invoice_buyer").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      document.querySelector("#invoice_data [name='number']").focus();
      toast.warning(t(["toast.invoiceInfo"]), { containerId: "all_toast" });
      return false;
    } else if (
      hasTransport === true &&
      !(vehiclePlate && transporter && destinationAddress)
    ) {
      toast.warning(t(["toast.emptyTransporter"]), {
        containerId: "all_toast",
      });
    } else {
      const inCompleteItems = invoice.items
        .filter(
          (item) =>
            item.code?.length < 1 ||
            item.name?.length < 1 ||
            item.quantity?.length < 1 ||
            item.priceWithVat?.length < 1
        )
        .map((item, index) => index);
      if (inCompleteItems?.length > 0) {
   
        toast.warning(t(["toast.itemsInfo"]), { containerId: "all_toast" });
        return false;
      } else {
        return true;
      }
    }
  };

  const handleInvoice = ({autosave, autoSaveState}) => {
    let newState =autoSaveState ?? invoice
    const validateInvoiceFields = validateInvoice({ setErrors, toast, state: newState,autoSaveState,t })
    if (!validateInvoiceFields) return

    if (
      (new Date(newState.invoiceStartDate).getMonth() !==
      new Date(newState.invoiceEndDate).getMonth())
    ) {
      if(!autoSaveState){
        toast.error(
          `${t(["invoice.sDate"])} dhe ${t([
            "invoice.eDate",
          ])} duhet te jene brenda ne te njejtin muajin !`,
          { containerId: "all_toast" }
        );
      }

      return;
    }
    if (newState.businessUnitCode) newState.businessUnitCode = newState.businessUnitCode.trim();
    if (newState.opCode) newState.opCode = newState.opCode.trim();
    if (newState.parties.buyer.name) newState.parties.buyer.name = newState.parties.buyer.name.trim();
    if (newState.parties.seller.name) newState.parties.seller.name = newState.parties.seller.name.trim();
    if (newState.internalId) newState.internalId = newState.internalId.trim();

    let loadingToastId=null
    if(autoSaveState){
      loadingToastId=toast.loading("Auto Saving...",{
        containerId: "all_toast",
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: false,
      })
    }

    setLoading(true);

    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          ...func.parseCustomInvoiceRequest(newState),
          action: invoiceActions[1],
          status: invoiceStatuses[0],
        },
        nuis: company.nuis.trim(),
      })
      .then((res) => {
        if(loadingToastId){
          setTimeout(()=>{
            toast.dismiss(loadingToastId)
          },2000)
        }
        if (res?.data?.status === true) {

          if(!autoSaveState)toast.success(t(["toast.draftSaved"]), { containerId: "all_toast" });
          const parsedInvoice=func.parseCustomInvoiceResponse(res.data.content[0])

          lastStateRef.current = parsedInvoice
          lastStateHelper.current={saved:true,date:moment().format("HH:mm:ss")}
          setInvoice(parsedInvoice);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleReadyForApproval = async () => {
    let parsedInvoice = func.validateMultiPayment({ state: invoice, toast })

    if(parsedInvoice.sumInv){
      delete parsedInvoice["iic_ref"]
      delete parsedInvoice["refInvIssueDateTime"]
    }

    const {
      type,
      typeOfSelfInvoice,
      invoiceEndDate,
      invoiceStartDate,
      rate,
      issueDate,
      dueDate,
    } = parsedInvoice;

    const { buyer, seller, ...rest } = parsedInvoice.parties;

    const issDate = moment(issueDate).endOf("day");
    const today = moment().endOf("day");
    const validateInvoiceFields = validateInvoice({ setErrors, toast, state: invoice, validateOnlyItems: false,setPartiesDialog })
      if (parsedInvoice.internalId) parsedInvoice.internalId = parsedInvoice.internalId.trim();
    if (!validateInvoiceFields) return
        // Check if payment method is "cash" and total invoice exceeds 500,000

  if (parsedInvoice?.parties?.buyer?.buyerIDType !== "NUIS" && parsedInvoice.paymentMethodType === "cash" &&((parsedInvoice.currency =="ALL" && (parseFloat(parsedInvoice?.invoiceTotalWithVat) > 500000)) || (parsedInvoice.currency !== "ALL" && parseFloat(parsedInvoice?.invoiceTotalWithVat) > 5000) )) {
    const confirmation = await Swal.fire({
      text: t("toast.amountExceedesAlert"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#007567",
      confirmButtonText: t("OK"),
      cancelButtonText: t("invoice.backToInvoice"),
    });

    if (!confirmation.isConfirmed) {
      return;
    }
  }
    if (
      parsedInvoice?.parties?.buyer?.buyerIDType === "NUIS" &&
      parsedInvoice?.paymentMethodType === "cash" &&
      parsedInvoice?.invoiceTotalWithVat > 150000
    ) {
      toast.error(t(["toast.errorPos"]), {
        containerId: "all_toast",
      });
    }
      else if (!rate) {
      toast.error(t(["toast.noExchangeRate"]), {
        containerId: "all_toast",
      });
    } else if (issDate > today) {
      toast.error(t(["toast.issueDateErr"]), {
        containerId: "all_toast",
      });
    } else if (
      buyer.buyerIDType === "NUIS" &&
      !new RegExp("[a-zA-Z]{1}[0-9]{8}[a-zA-Z]{1}").test(buyer.tin)
    ) {
      toast.error(t(["toast.incorrectNiptForBuyer"]), {
        containerId: "all_toast",
      });
    } else if (!invoiceEndDate && invoiceStartDate) {
      toast.error("Please complete end date", { containerId: "all_toast" });
    } else if (invoiceEndDate && !invoiceStartDate) {
      toast.error("Please complete Start Date", { containerId: "all_toast" });
    } else if (
      parsedInvoice.parties.seller.tin === buyer.tin &&
      parsedInvoice.profileId != "P10" &&
      parsedInvoice.profileId != "P12"
    ) {
      toast.error(t(["toast.diffNipt"]), { containerId: "all_toast" });
    } else {
      if (validatedInvoice()) {
        setLoading(true);
        mainAxios
          .post("endpoint/v2.2/saveOrUpdate", {
            object: "CustomInvoice",
            content: {
              ...func.parseCustomInvoiceRequest(parsedInvoice),
              action: invoiceActions[5],
              status: invoiceStatuses[1],
            },
            nuis: company.nuis,
          })
          .then((res) => {
            if (res?.data?.status === true) {
              toast.success(t(["toast.draftApproval"]), {
                containerId: "all_toast",
              });
              setInvoice(func.parseCustomInvoiceResponse(res.data.content[0]));
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    }
  };

   const handleDuplicateInvoice = async  () => {
    const validateInvoiceFields = validateInvoice({ setErrors, toast, state: invoice });
    if (!validateInvoiceFields) return;
    setDuplicateLoading(true)
    await duplicateInvoice({ invoice,company,t,user,onSuccess:(res)=>{
      const duplicatedInvoice = func.parseCustomInvoiceResponse(res.data.content[0]);
      setInvoice(duplicatedInvoice);
      props.history.push("/edit-invoice/" + res.data.content[0].id);
    }});
    setDuplicateLoading(false)
  };

  const handleApprove = () => {
    if (!invoice.invoiceTotalVat.includes("-") || invoice.type === "384") {
      setLoading(true);
      mainAxios
        .post("endpoint/v2.2/saveOrUpdate", {
          object: "CustomInvoice",
          content: {
            ...func.parseCustomInvoiceRequest(invoice),
            action: invoiceActions[2],
            status: invoiceStatuses[2],
          },
          nuis: company.nuis,
        })
        .then((res) => {
          if (res?.data?.error) {
            toast.error(res?.data?.error.errorDescription, {
              containerId: "all_toast",
            });
            setRefreshInvoice((state) => !state);
          } else {
            if (res?.data?.status === true) {
              toast.success(t(["toast.successApproval"]), {
                containerId: "all_toast",
              });
              setInvoice(func.parseCustomInvoiceResponse(res.data.content[0]));
            }
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      toast.warning(t(["toast.invoice.approve.warning"]), {
        containerId: "all_toast",
      });
    }
  };


  const handleRefreshStatus=()=>{
    if (!invoice.invoiceTotalVat.includes("-") || invoice.type === "384") {
      setLoading(true);
      mainAxios
        .post("endpoint/v2.2/saveOrUpdate", {
          object: "RefreshStatus",
          content: {
            ...func.parseCustomInvoiceRequest(invoice),
            action: invoiceActions[2],
            status: invoiceStatuses[2],
          },
          nuis: company.nuis,
        })
        .then((res) => {
          setRefreshInvoice((state)=>!state)
          if (res?.data?.error) {
            toast.error(res?.data?.error.errorDescription, {
              containerId: "all_toast",
            });
          } else {
            if (res?.data?.status === true) {
              toast.success(t(["invoice.refreshedInvoice"]), {
                containerId: "all_toast",
              });
            }
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      toast.warning(t(["toast.invoice.approve.warning"]), {
        containerId: "all_toast",
      });
    }
  }
  const handleReject = () => {
    setLoading(true);
    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          ...func.parseCustomInvoiceRequest(invoice),
          action: invoiceActions[3],
          status: invoiceStatuses[0],
        },
        nuis: company.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(t(["toast.invoiceRejected"]), {
            containerId: "all_toast",
          });
          setInvoice(func.parseCustomInvoiceResponse(res.data.content[0]));
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleDelete = () => {
    setLoading(true);
    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          ...func.parseCustomInvoiceRequest(invoice),
          action: invoiceActions[4],
          status: invoiceStatuses[3],
        },
        nuis: company.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(t(["toast.draftDeleted"]), {
            containerId: "all_toast",
          });
          if (props?.isPos) {
            props.history.push("/pos-transactions");
          } else {
            props.history.push("/my-invoices");
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => {
    setLoading(true);
    const correctiveInvoice = JSON.parse(JSON.stringify(invoice));
    delete correctiveInvoice["id"];
    delete correctiveInvoice["invoiceHistorics"];
    delete correctiveInvoice["internalId"];
    delete correctiveInvoice["summaryInvIICRefs"];


  // Reset subSequenceDelivType if it exists
  if (correctiveInvoice?.subSequenceDelivType != "" && correctiveInvoice?.subSequenceDelivType != null) {
    correctiveInvoice.subSequenceDelivType = "";
  }

    const opCode=user?.userCompanyOperator?.find(
      (uco) => parseInt(uco.company) === parseInt(selectedCompany)
    )?.operator ?? correctiveInvoice.opCode

    correctiveInvoice.opCode = opCode
    if(correctiveInvoice?.discount?.id) delete correctiveInvoice.discount.id

    correctiveInvoice.attachments = correctiveInvoice.attachments.map(
      (attachment) => {
        const { id, ...rest } = attachment;
        return rest;
      }
    );

    correctiveInvoice.items = correctiveInvoice.items.map((item) => {
      const { id, quantity, totalWithoutVat, totalWithVat, ...rest } = item;

      return {
        ...rest,
        quantity: -1 * quantity,
      };
    });

    correctiveInvoice.invoiceFees = correctiveInvoice?.invoiceFees?.map(fee => {
      const { id,...restFee } = fee
      return {...restFee,feeAmount:-1*fee.feeAmount}
    }) ?? []

    if (correctiveInvoice?.paymentMethod?.length > 0) {
      correctiveInvoice.paymentMethod = correctiveInvoice.paymentMethod.map(payment => {
        const { paymentMethodType, paymentMeans } = invoice
        let paymentMeansValue = payment.paymentMeansValue

        if (!paymentMeansValue) {
          const paymentOptions = paymentMethodType == "cash" ? typeOfPaymentMeansCash(t) : typeOfPaymentMeansNonCash(t)
          const currentPaymentOption = paymentOptions.find(opt => opt.paymentMeans === paymentMeans)
          if (currentPaymentOption?.paymentMeansValue) paymentMeansValue = currentPaymentOption.paymentMeansValue
        }

        return {
          ...payment,
          id:null,
          paymentAmount: -1 * payment.paymentAmount,
          paymentMeansValue
        }
      })
    }
    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          ...func.parseCustomInvoiceRequest(correctiveInvoice),
          issueDate: new Date(),
          action: invoiceActions[0],
          status: invoiceStatuses[0],
          iic: null,
          fic: null,
          eic: null,
          recordDate: null,
          recordUser: null,
          number: "",
          profileId: "P10",
          type: "384",
          correctiveInv: true,
          correctiveInvType: "CORRECTIVE",
          badDebtInv: false,
          reverseCharge: false,
          selfInvoice: false,
          sumInv: false,
          cisStatus: null,
          cisError: null,
          internalId: "",
          iic_ref: correctiveInvoice.iic,
          refInvIIC: correctiveInvoice.iic,
          refInvIssueDateTime: invoice.issueDate,
        },
        nuis: company.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          // return

          toast.success("Corrective Invoice Created!", {
            containerId: "all_toast",
          });
          if (props?.isPos) {
            props.history.push("/edit-pos/" + res?.data?.content[0].id);
          } else {
            props.history.push("/edit-invoice/" + res?.data?.content[0].id);
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };


  const handleSummaryInvoiceChange=(e)=>{
    const value = e.target.checked
    let summaryInvIICRefs
    if(value){
      summaryInvIICRefs =[
        {
          iicRef:"",
          iicRefIssueDateTime:""
        }
      ]
    }
    setInvoice((invoiceState) => ({
      ...invoiceState,
      sumInv: value,
      summaryInvIICRefs
    }));
  }

  /** USER ROLES
   * "Role Name: sysadmin,  ID: 1"
   * "Role Name: admin,     ID: 2"
   * "Role Name: useradmin, ID: 3"
   * "Role Name: Create ,   ID: 4"
   * "Role Name: Approve ,  ID: 5"
   * "Role Name: Purchase,  ID: 6"
   * "Role Name: View,      ID: 7"
   */
  const isViewRole = user.role.id === 7;
  const userCanCreate = [1, 2, 4, 15].includes(user.role.id);
  const userCanSave = [1, 2, 4, 15].includes(user.role.id);
  const userCanSubmitForApproval = [1, 2, 4, 15].includes(user.role.id);
  const userCanDelete = [1, 2, 15].includes(user.role.id);
  const userCanCancel = [1, 2, 15].includes(user.role.id);
  const userCanApproveOrReject = [1, 2, 5, 15].includes(user.role.id);
  const userCanDuplicate = !isViewRole;

  let disabled = false;
  let showRefresh=false

  if (invoice){
    disabled =
      invoice.status.status === "READY_FOR_APPROVAL" ||
      invoice.status.status === "APPROVED";
      
      let status = invoice?.status?.status;
      let resendStatuses = refreshStatuses?.filter(resendStatus=>resendStatus?.isActive==true)?.map(resendStatus=>resendStatus?.status)?? []
      let staticRefreshConditions=(invoice?.einvoice && invoice?.cisStatus==="SUCCESS" && (!invoice?.eic || invoice.eic=="")) || invoice?.cisStatus =="PENDING"
  
      showRefresh= (resendStatuses.includes(status)) || staticRefreshConditions
  }

  let badgeClass = "secondary";
  let statusLabel = "Draft";


  let buttons = (
    <>
      {invoice?.status?.id === 7 && <a
        href="#"
        style={{minWidth:"max-content"}}
        className={
          "btn btn-sm btn-secondary mr-2 mb-2 mb-md-0 " +
          (loadingPdf?.loading ? " disabled" : "")
        }
        onClick={(e) => {
          e.stopPropagation();
          showInvoicePdf({key:"id", invoice,e});
        }}
      >
        <FontAwesomeIcon
          icon={faFilePdf}
          className="mr-1"
        />
        Print no Fisc
      </a>
      }

      {userCanDelete && !showRefresh && (
        <button
          className="btn btn-sm btn-danger ml-2 mb-2 mb-md-0"
          style={{minWidth:"max-content"}}
          disabled={loading || duplicateLoading}
          onClick={handleDelete}
        >
          {loading && <Loader size="xs" color="white" />} {t(["common.deleteDraft"])}
        </button>
      )}
      {userCanSave && (
        <button
          className="btn btn-sm btn-success ml-2 mb-2 mb-md-0 d-inline-flex align-items-center justify-content-center"
          style={{minWidth:"max-content", whiteSpace:"nowrap", gap:"6px"}}
          disabled={loading || duplicateLoading}
          onClick={handleInvoice}
        >
          {loading && <Loader size="xs" color="white" />} {t(["common.save"])}
        </button>
      )}
      {userCanSubmitForApproval && (
        <button
          className="btn btn-sm btn-primary ml-2  mb-2 mb-md-0"
          disabled={loading || duplicateLoading}
          onClick={handleReadyForApproval}
          style={{minWidth:"max-content"}}
        >
          {loading && <Loader size="xs" color="white" />} {t(["common.submitApproval"])}
        </button>
      )}
    </>
  );

  if (invoice) {
    let status = invoice?.status?.status;

    if (showRefresh ) {
      disabled=true
      buttons = (
        <>
          <button
            className="btn btn-warning  mb-2 mb-md-0"
            disabled={loading}
            style={{ minWidth: "80px" }}
            onClick={handleRefreshStatus}
          >
            {loading && <Loader size="xs" color="white" />} <FontAwesomeIcon icon={faRedo} className="mr-1" /> Refresh
          </button>
        </>
      );
    } else if (status === "READY_FOR_APPROVAL") {
      badgeClass = "info";
      statusLabel = "Ready For Approval";
      buttons = (
        <>
        <a
               href="#"
               style={{minWidth: "max-content"}}
              className={
                "btn btn-sm  btn-secondary d-flex-align-items-center mr-3  mb-2 mb-md-0" +
                (loadingPdf ? " disabled" : "")
              }
              onClick={(e) => {
                e.stopPropagation();
                showInvoicePdf({key:"id", invoice,e});
              }}
            >
              <FontAwesomeIcon
                icon={faFilePdf}
                className="mr-1"
              />
              Print no Fisc
            </a>
          
          {userCanApproveOrReject && (
            <button
              className="btn btn-sm btn-danger mr-3 mb-2 mb-md-0 d-inline-flex align-items-center justify-content-center"
              disabled={loading}
              style={{ minWidth: "80px", whiteSpace: "nowrap", gap: "6px" }}
              onClick={handleReject}
            >
              {loading && <Loader size="xs" color="white" />} {t(["status.reject"])}
            </button>
          )}
          {userCanApproveOrReject && (
            <button
              className="btn btn-sm btn-primary  mb-2 mb-md-0 d-inline-flex align-items-center justify-content-center"
              disabled={loading}
              style={{ minWidth: "80px", whiteSpace: "nowrap", gap: "6px" }}
              onClick={handleApprove}
            >
              {loading && <Loader size="xs" color="white" />} {t(["status.approve"])}
            </button>
          )}
        </>
      );
    } else if (status === "APPROVED") {
      badgeClass = "success";
      statusLabel = "Approved";
      buttons = invoice && invoice.status.id === 9 && (
        <>
          {userCanCancel && (
            <button
              className="btn btn-sm btn-danger ml-3"
              style={{ minWidth: "80px" }}
              onClick={handleCancel}
            >
              {loading && <Loader size="xs" color="white" />} {t("common.cancelInvoice")}
            </button>
          )}
        </>
      );
    }
  }

  const handleInvoiceTcrCodeChange = (tcrCode) => {
    setInvoice((invoice) => ({
      ...invoice,
      tcrCode,
    }));
  };
  const handleSelfInvoiceChange = (e) => {
    const value = e.target.checked;
    setInvoice((invoice) => ({
      ...invoice,
      selfInvoice: value,
    }));
    if (value === false) {
      setInvoice((invoice) => ({
        ...invoice,
        typeOfSelfInvoice: "",
        reverseCharge: false,
      }));
    }
  };

  const handleSelfInvoiceTypeChange = (key, value) => {
    setInvoice((invoice) => ({
      ...invoice,
      [key]: value,
    }));
  };

  const handleReverseChargeChange = (e) => {
    const value = e.target.checked;
    setInvoice((invoice) => ({
      ...invoice,
      reverseCharge: value,
    }));
  };

  const handlePaymentMethodTypeChange = (newPaymentMethodType) => {
    const { paymentMethodType, paymentMeans, ...rest } = invoice;

    let newPaymentMeans = "";

    if (paymentMethodType === "noncash") newPaymentMeans = "10";
    else newPaymentMeans = "ZZZ";
    setInvoice((invoice) => ({
      ...invoice,
      paymentMethodType: newPaymentMethodType,
      paymentMeans: newPaymentMeans,
    }));
  };

  const handlePaymentMeansChange = (key, value) => {
    setInvoice((invoice) => ({
      ...invoice,
      [key]: value,
    }));
  };

  const isLoadingPdf=loadingPdf?.id==invoice?.id && loadingPdf?.loading

  const handlePrint = () => {
    const content = document.getElementById("thermalPrinterInvoice");
    const pri = document.getElementById("ifmcontentstoprint").contentWindow;

    pri.document.open();
    pri.document.write(
      `<html><style>@page{margin:0mm auto;margin-bottom:10mm;font-family: 'EB Garamond', serif;}</style>${content.innerHTML}</html>`
    );
    pri.document.close();
    pri.focus();
    pri.print();
  };

  if (invoice) {
    if (props.isPos && invoice.source !== "MP") {
      return <Page404 />;
    } else if (!props.isPos && invoice?.source !== "MI") {
      return <Page404 />;
    }
  }

  const handleInvoiceChange = (value, key) => {
    const keys = key.split(".");

    switch (keys.length) {
      case 1:
        setInvoice((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: value,
        }));
        break;
      case 2:
        setInvoice((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: {
            ...invoiceState[keys[0]],
            [keys[1]]: value,
          },
        }));
        break;
      case 3:
        setInvoice((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: {
            ...invoiceState[keys[0]],
            [keys[1]]: {
              ...invoiceState[keys[0]][keys[1]],
              [keys[2]]: value,
            },
          },
        }));
        break;
      default:
        return;
    }
  };

  function changeOnlyFisc() {
    if (!invoice.einvoice) {
      setInvoice((invoiceState) => ({
        ...invoiceState,
        einvoice: true,
        parties: {
          ...invoiceState.parties,
          buyer: {
            ...invoiceState.parties.buyer,
            buyerIDType: "NUIS",
          },
        },
        paymentMethodType: "noncash",
        paymentMeans: "ZZZ",
      }));
    } else {
      Swal.fire({
        title: t(["notification.einvoice"]),
        icon: "warning",
        width: "800px",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.value == true) {
          setInvoice((invoiceState) => ({
            ...invoiceState,
            einvoice: false,
          }));
        }
      });
    }
  }

  const sideBarToggle=({...props}={})=>(
    <div className="side-bar-handle" style={{...props }}>
      <div className="side-bar-handle-content"  onClick={() => setSideBarVisible((barVisible)=>barVisible ==="false"?"true":"false")}>
        {/* <img src={sideMenuIcons} alt="side"/> */}
        <FontAwesomeIcon icon={sideBarVisible==="true"?faChevronRight:faChevronLeft} className="" />
      </div>
    </div>
  )


  return !pageLoading ? (
    invoice ? (
      <>
        <div className="demoInvoice">
          {(invoice.iic || invoice.eic || invoice.fic ) && (
            <div className="card border-0 card-accordion d-flex justify-content-center align-items-stretch align-items-md-center" >
              <Accordion
                heading={
                  <>
                    {invoice.iic && (
                      <a
                        href="#"
                        className={
                          "btn btn-sm btn-info d-flex-align-items-center ml-3"
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePrint();
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faPrint}
                          className="mr-1"
                        />
                        Print Thermal Fisc
                      </a>
                    )}

                  
                    {invoice.iic && (
                      <a
                        href="#"
                        className={
                          "btn btn-sm btn-info d-flex-align-items-center ml-3" +
                          ((isLoadingPdf && loadingPdf?.key=="iic") ? " disabled" : "")
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          showInvoicePdf({key:"iic", invoice,e});
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faFilePdf}
                          className="mr-1"
                        />
                        Print Fisc
                      </a>
                    )}
                    {invoice.eic && (
                      <a
                        href="#"
                        className={
                          "btn btn-sm btn-info d-flex-align-items-center ml-3" +
                          ((isLoadingPdf && loadingPdf?.key=="eic")  ? " disabled" : "")
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          showInvoicePdf({key:"eic", invoice});
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faFilePdf}
                          className="mr-1"
                        />
                        Print Einv
                      </a>
                    )}
                    {invoice.qrurl && (
                      <a
                        href={invoice.qrurl}
                        onClick={(e) => e.stopPropagation()}
                        className="btn btn-sm btn-info d-flex-align-items-center ml-3"
                        target="_blank"
                      >
                        QR Url
                      </a>
                    )}
                    {invoice.iic && (
                      <a
                        href="#"
                        className={
                          "btn btn-sm btn-info d-flex-align-items-center ml-3"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          func.sendEmailPdf(
                            invoice.iic,
                            invoice.customer,
                            invoice?.parties?.buyer?.tin,
                            t
                          );
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faPaperPlane}
                          className="mr-1"
                        />
                        {t("email.sendByEmail")}
                      </a>
                    )}
                  </>
                }
              >
                <div style={{ padding: "10px 20px 20px" }}>
                  <p>
                    <strong>FIC: </strong> {invoice.fic}
                  </p>
                  <p>
                    <strong>IIC: </strong> {invoice.iic}
                  </p>
                  <p>
                    <strong>EIC: </strong> {invoice.eic}
                  </p>
                </div>
              </Accordion>
            </div>
          )}
          <div className="row ">
            <div className="d-flex justify-content-center align-items-center">


            </div>

            <div className={`col-12 col-md-${sideBarVisible==="true"?"10":"12"}`} style={{position:"relative"}}>

              <div className="card p-2">
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-1 mt-1 invoice-header">
                  <div className="d-flex align-items-start align-items-md-center flex-wrap invoice-header-left">
                    <h3 className="mb-0 mr-4">
                      {t("invoice.editDraft")}
                      <small className={`badge badge-${badgeClass} ml-2`} data-tooltip-id="global-tooltip" data-tooltip-content="Profisc Status">
                        {statusLabel}
                      </small>
                      <div className="d-none">
                        {invoice?.action?.action === "APPROVED" && (
                          <ThermalPrinterInvoiceContent invoice={invoice} />
                        )}
                      </div>
                      {!invoice.cisStatus ? null : invoice.cisStatus ===
                        "SUCCESS" ? (
                        <small className="badge badge-success ml-2" data-tooltip-id="global-tooltip" data-tooltip-content="Cis Status">
                          Success
                        </small>
                      ) : invoice.cisError ? (
                        <small
                          className={`badge badge-${showRefresh?"warning":"danger"} d-inline-flex align-items-center ml-2`}
                          data-tooltip-id="global-tooltip" data-tooltip-content={invoice.cisError}
                        >
                         {showRefresh? <span style={{fontWeight:600}}>PENDING</span> :"Error"}
                          <FontAwesomeIcon
                            icon={faQuestionCircle}
                            className="ml-2"
                          />
                        </small>
                      ) : (
                        <small className="badge badge-danger ml-2">Error</small>
                      )}
                  {invoice?.internalPaymentStatus &&  <small className={`badge badge-info ml-2`}  data-tooltip-id="global-tooltip" data-tooltip-content="Payment Status">
                  {translateLabel(invoice?.internalPaymentStatus?.engName,invoice?.internalPaymentStatus?.albName,i18n)}
                  </small>}
                      {/* Mobile: Duplicate inline with title */}
                      { invoice.status.status !== "ERROR" && userCanDuplicate && (
                        <button
                          onClick={handleDuplicateInvoice}
                          className={`btn btn-sm ${duplicateLoading || loading ?"disabled":""} btn-outline-primary d-inline-flex d-md-none align-items-center ml-2`}
                          style={{minWidth:"max-content"}}
                        >
                          {duplicateLoading ? <FontAwesomeIcon className='mr-1' size='lg' icon={faSpinner} spin /> : <FontAwesomeIcon className="mr-1" icon={faCopy} />}
                          {t("invoice.duplicate")}
                        </button>
                      )}
                    </h3>
                    <div className="d-flex align-items-center flex-wrap invoice-header-checks" style={{gap: "0.5rem 0.75rem"}}>
                      <div className="form-check me-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="isEinvoice"
                          name="isEinvoice"
                          checked={!invoice.einvoice}
                          onChange={changeOnlyFisc}
                          disabled={invoice.type == 389 || disabled}
                          style={{ cursor: "pointer" }}
                        />
                        <label
                          htmlFor="isEinvoice"
                          className="form-check-label"
                          style={{ cursor: "pointer" }}
                        >
                          {t("parameters.onlyFiscalization")}
                          <PopOver title={t("hints.onlyFiscalization")} />
                        </label>
                      </div>
                      <div className="form-check me-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="sumInv"
                          name="sumInv"
                          checked={invoice.sumInv}
                          onChange={(e) =>handleSummaryInvoiceChange(e)}
                          disabled={disabled}
                          style={{ cursor: "pointer" }}
                        />
                        <label
                          htmlFor="sumInv"
                          className="form-check-label"
                          style={{ cursor: "pointer" }}
                        >
                          {t("invoice.summaryInvoice")}
                          <PopOver title="Zgjidhni kte opsion ne qofte se fature eshte permbledhese" />
                        </label>
                      </div>
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          id="invoice_autosave"
                          className="form-check-input"
                          checked={invoiceAutosave==="1"}
                          onChange={(event) => {
                            setInvoiceAutosave(event.target.checked ? "1" : "0")
                          }}
                          style={{ cursor: "pointer" }}
                        />
                        <label className="form-check-label" htmlFor="invoice_autosave" style={{ cursor: "pointer" }}>
                          {t("invoice.autoSave")}
                          <PopOver title={t("invoice.autoSaveDesc")} />
                        </label>
                      </div>
                    </div>
                    {lastStateHelper?.current?.date && <div style={{fontSize:12,fontWeight:700}}>
                      {t("invoice.lastAutosaved")}: {lastStateHelper?.current?.date ?? ""}
                    </div>}
                  </div>
                  <div className="mt-2 mt-md-0">
                    <div className="d-flex align-items-start justify-content-start justify-content-md-end flex-md-nowrap flex-wrap invoice-header-right">
                      {userCanCreate && (
                        <Link to="/create-invoice" className="btn btn-sm btn-info d-none d-md-inline-block mr-2 mb-2 mb-md-0">
                          {t("navbar.create")}
                        </Link>
                      )}
                      { invoice.status.status !== "ERROR" && userCanDuplicate && (
                        <button
                          onClick={handleDuplicateInvoice}
                          className={`btn btn-sm ${duplicateLoading || loading ?"disabled":""} btn-outline-primary d-none d-md-inline-flex align-items-center mr-2 mb-2 mb-md-0`}
                          style={{minWidth:"max-content"}}
                        >
                          {duplicateLoading ? <FontAwesomeIcon className='mr-1' size='lg' icon={faSpinner} spin /> : <FontAwesomeIcon className="mr-1" icon={faCopy} />}
                          {t("invoice.duplicate")}
                        </button>
                      )}
                      {buttons}
                    </div>
                  </div>
                </div>

                <div className="my-2 border-top border-success"></div>

                {/* Desktop: three columns side-by-side */}
                <div className="row d-none d-md-flex mb-3" style={{alignItems: "stretch"}}>
                  <div className="col-12 col-md-4" style={{borderRight: "1px solid #dee2e6"}}>
                    <DemoInvoiceFiscalization
                      handleInvoiceTcrCodeChange={handleInvoiceTcrCodeChange}
                      handleSelfInvoiceChange={handleSelfInvoiceChange}
                      handleSelfInvoiceTypeChange={handleSelfInvoiceTypeChange}
                      handleReverseChargeChange={handleReverseChargeChange}
                      handlePaymentMethodTypeChange={
                        handlePaymentMethodTypeChange
                      }
                      handlePaymentMeansChange={handlePaymentMeansChange}
                      invoiceState={invoice}
                      setInvoiceState={setInvoice}
                      disabled={disabled}
                      errors={errors}
                      setErrors={setErrors}
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <DemoParties
                      invoiceState={invoice}
                      setInvoiceState={setInvoice}
                      disabled={disabled}
                      partiesDialog={partiesDialog}
                      setPartiesDialog={setPartiesDialog}
                      errors={errors}
                      setErrors={setErrors}
                      edit={true}
                    />
                  </div>
                  <div className="col-12 col-md-4" style={{borderLeft: "1px solid #dee2e6"}}>
                    <DemoInvoiceDatas
                      handleInvoiceChange={handleInvoiceChange}
                      invoiceState={invoice}
                      setInvoiceState={setInvoice}
                      disabled={disabled}
                      errors={errors}
                      setErrors={setErrors}
                      edit={true}
                    />
                  </div>
                </div>

                {/* Mobile: wizard steps */}
                <div className="d-md-none">
                  <MobileInvoiceWizard errors={errors} steps={[
                    {
                      label: "Fiscalization",
                      errorKeys: ["issueDate", "dueDate", "rate", /^\d+_/],
                      content: (
                        <DemoInvoiceFiscalization
                          handleInvoiceTcrCodeChange={handleInvoiceTcrCodeChange}
                          handleSelfInvoiceChange={handleSelfInvoiceChange}
                          handleSelfInvoiceTypeChange={handleSelfInvoiceTypeChange}
                          handleReverseChargeChange={handleReverseChargeChange}
                          handlePaymentMethodTypeChange={handlePaymentMethodTypeChange}
                          handlePaymentMeansChange={handlePaymentMeansChange}
                          invoiceState={invoice}
                          setInvoiceState={setInvoice}
                          disabled={disabled}
                          errors={errors}
                          setErrors={setErrors}
                        />
                      ),
                    },
                    {
                      label: "Parties",
                      errorKeys: [/^parties\./],
                      content: (
                        <DemoParties
                          invoiceState={invoice}
                          setInvoiceState={setInvoice}
                          disabled={disabled}
                          partiesDialog={partiesDialog}
                          setPartiesDialog={setPartiesDialog}
                          errors={errors}
                          setErrors={setErrors}
                          edit={true}
                        />
                      ),
                    },
                    {
                      label: "Data",
                      errorKeys: ["buyer", "vehiclePlate", "transporter", "destinationAddress"],
                      content: (
                        <DemoInvoiceDatas
                          handleInvoiceChange={handleInvoiceChange}
                          invoiceState={invoice}
                          setInvoiceState={setInvoice}
                          disabled={disabled}
                          errors={errors}
                          setErrors={setErrors}
                          edit={true}
                        />
                      ),
                    },
                  ]} />
                </div>

                <DemoTable
                  invoiceState={invoice}
                  setInvoiceState={setInvoice}
                  disabled={disabled}
                  setErrors={setErrors}
                  errors={errors}
                  lastStateRef={lastStateRef}
                  lastStateHelper={lastStateHelper}
                />

                <div className="row mt-1 mx-1 notes-totals-row">
                  {/* InvoiceNotes */}
                  <div className="col-12 border-top col-md-6">
                    {!props.isPos && (
                      <DemoInvoiceTabsNAT
                        errors={errors}
                        invoiceState={invoice}
                        setInvoiceState={setInvoice}
                        disabled={disabled}
                        handleInvoiceChange={handleInvoiceChange}
                      />
                    )}
                  </div>
                  {/* /// */}
                  {/* InvoiceTotals */}
                  <div className="col-12 col-md-6 border-top total-list">
                    <DemoInvoiceTotals invoiceState={invoice} />
                  </div>
                  {/* /// */}
                </div>
              </div>
              {sideBarToggle({right:-2,left:"auto"})}
            </div>

            {/* sidreBar */}
            {sideBarVisible == "true" && (
              <div className="col-12 col-md-2 sidebar-col">
                <div className="pt-md-1 pt-xl-2">
                  <div
                    className="d-flex justify-content-start"
                  >
                    <AlertCertificate marginLeft={false}/>
                    <iframe
                      id="ifmcontentstoprint"
                      className="d-none"
                    ></iframe>
                  </div>
                  <DemoSideMenu
                    invoiceState={invoice}
                    setInvoiceState={setInvoice}
                    bankAccounts={bankAccounts}
                    disabled={disabled}
                  />
                </div>
              </div>
            )}

            {/*  */}
          </div>
        </div>
        {pdfEmbed}
      </>
    ) : (
      <Page404 />
    )
  ) : (
    <Loader />
  );
};

export default DemoEditInvoice;
